export default __webpack_public_path__ + "static/media/year-value.f1e322e4.jpeg";